import { render, staticRenderFns } from "./AudioReason.vue?vue&type=template&id=79231349&scoped=true&"
import script from "./AudioReason.vue?vue&type=script&lang=js&"
export * from "./AudioReason.vue?vue&type=script&lang=js&"
import style0 from "./AudioReason.vue?vue&type=style&index=0&id=79231349&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79231349",
  null
  
)

export default component.exports